import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import css from '@src/styles/components/aggregation/scoring.scss';
import Translation from '../Base/Translation';
import AdaptiveTrait from '../../AdaptiveTrait';

export default class Scoring extends React.Component {

    constructor(props) {

        super(props);

        // eslint-disable-next-line no-new
        new AdaptiveTrait(this);
    }

    static get propTypes() {

        return {
            className: PropTypes.string,
            value: PropTypes.number,
            recommendedLabel: PropTypes.string,
            checkScoreLink: PropTypes.string,
            alwaysRenderDesktop: PropTypes.bool,
            maxWidth: PropTypes.bool,
        };
    }

    renderMobile() {

        if (this.props.alwaysRenderDesktop)
            return this.renderDesktop();

        if (!this.props.value)
            return null;

        const
            grades = this.getScoreGrades(),
            classes = [style('flex flex-wrap gap-md'), this.props.className];

        let
            lowGrade = null,
            highGrade = null;

        grades.forEach((grade) => {

            if (grade.min >= this.props.value && lowGrade == null)
                lowGrade = grade;

            if (grade.min >= this.props.value)
                highGrade = grade;
        });

        if (!lowGrade)
            lowGrade = grades[0]; // eslint-disable-line prefer-destructuring

        if (!highGrade)
            highGrade = grades[grades.length - 1];

        return (
            <div className={ classes.join(' ') }>

                <Translation className={ style('w-full text-small') } tag='ui.rating.recommended.title' />

                <div className={ style('flex items-center gap-md', css) }>

                    {/* min - max values */}
                    <div className={ style('scoring', css) } title={ this.props.value }>
                        { this.createDomFromGrade(lowGrade, true) } - { this.createDomFromGrade(highGrade, true) }
                    </div>

                    { this.getHtmlCheckScoreLink() }

                </div>
            </div>
        );
    }

    renderDesktop() {

        if (!this.props.value)
            return null;

        const
            grades = this.getScoreGrades(),
            classes = [style('flex flex-wrap gap'), this.props.className];

        if (this.props.maxWidth)
            classes.push(style('scoring--max-width', css));

        return (
            <div title={ this.props.value } className={ classes.join(' ') }>

                <Translation className={ style('w-full text-small') } tag='ui.rating.recommended.title' />

                {/* min - max values */}
                <div className={ style('scoring scoring--desktop', css) } title={ this.props.value }>
                    { grades.map((grade) => this.createDomFromGrade(grade, this.isActiveGrade(grade)), grades) }
                </div>

                { this.getHtmlCheckScoreLink() }


            </div>
        );
    }

    getHtmlCheckScoreLink() {

        return <a className={ style('w-full') } target='_blank' href={ this.getCheckScoreLink() }>
            <Translation tag='ui.rating.find-out-your-rating' />
        </a>;
    }

    isActiveGrade({ min }) {

        return min >= this.props.value;
    }

    createDomFromGrade({ min, className }, isActive) {

        return <div key={ min } className={ style([className, isActive ? 'active' : null].join(' ').trim(), css) }>
            { min }
        </div>;
    }

    getScoreGrades() {

        return [
            { min: 0, className: 'scoring-line scoring-line--low' },
            { min: 300, className: 'scoring-line scoring-line--low' },
            { min: 650, className: 'scoring-line scoring-line--medium' },
            { min: 1000, className: 'scoring-line scoring-line--high' },
        ];
    }

    getCheckScoreLink() {

        return this.props.checkScoreLink;
    }

}